import Vue from 'vue'
import {
  Toast,
  Dialog,
  Field,
  Form,
  Button,
  Icon,
  Uploader,
  Switch,
  Loading,
  DatetimePicker,
  Popup,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
  Stepper,
  Area,
  Search,
  PullRefresh
} from 'vant'
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Form)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Uploader)
Vue.use(Switch)
Vue.use(Loading)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Stepper)
Vue.use(Area)
Vue.use(Search)
Vue.use(PullRefresh)
